import axios from 'axios';
import { generateQueryParams } from 'utils/generateQueryParams';

export const UGDService = {
  async getUGD(page, perPage) {
    const params = generateQueryParams({
      page,
      size: perPage,
    });

    const res = await axios.get('taxagencies/', { params });

    if (res.status === 200) {
      return res.data;
    }
    return Promise.reject();
  },
  async getAllUGD() {
    const res = await axios.get('taxagencies/all/');

    if (res.status === 200) {
      return res.data;
    }
    return Promise.reject();
  },
  async createUGD(data) {
    const res = await axios.post('taxagencies/', data);

    if (res.status === 201) {
      return res.data;
    }
    return Promise.reject();
  },
  async editUGD(data, id) {
    const res = await axios.put(`taxagencies/${id}/`, data);

    if (res.status === 200) {
      return true;
    }
    return Promise.reject();
  },
  async deleteUGD(id) {
    const res = await axios.delete(`taxagencies/${id}/`);

    if (res.status === 200) {
      return true;
    }
    return Promise.reject();
  },
};
